<template>
<div @mousemove="handleMouse" @click="handleMouse" @click.right="handleMouse"  class="login">
  <Header />

  <div  class="bg-image"></div>

  <div  class="login-area">
    <div class="section">
      <h1 class="white--text mb-7 text-center">Digite seu CPF ou CNPJ</h1>

       <div class="card login-card py-14">
          <v-form ref="form" autocomplete="off" @submit.prevent="handleForm">

          <v-text-field
              ref="inputRef" 
              class="input-field mb-7"
              v-model="input"
              @input="onInputChange" 
              color="black" 
              :rules="[() => !!input || 'Este campo é obrigatório']" 
              placeholder="000.000.000-00" 
              prepend-inner-icon="mdi-card-account-details" 
              outlined
              autofocus
              clearable
            >
            </v-text-field>

            <strong v-if="showMessage && errorMessage" class="red--text">{{errorMessage}}</strong>

            <v-btn
              class="btn mt-4" block 
              color="primary"
              :disabled="isLoading"
              :loading ="isLoading"
              type="submit"
              @click.right="handleForm"
            >
              <img src="@/assets/ic-login.png" class="mr-2" alt=""> 
              Entrar
              <template v-slot:loader>
                <span>Carregando...</span>
              </template>
            </v-btn>
          </v-form>
        </div>
    </div>
  </div>
  <div class="keyboard">
    <NumberKeyboard 
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
    />
    </div>
</div>
</template>

<script>
import Header from '@/components/Header'

import NumberKeyboard from '../../NumberKeyboard'

import config from "@/config.js";

import telyApi from "@/services/telyApi";
import {unMaskSpecialChacaracters, cpfCnpj} from '@/services/unMask.service'
import {errorUserQuery} from '@/services/message.service'

import userStore from "@/store/user.store"
import adminStore from "@/store/admin.store"

import {createLog} from '@/controllers/user.controller'

export default {
  components: {Header,NumberKeyboard},
  data () {
    return {
      isLoading: false,
      showMessage: false,
      handleSetTimeout: '',
      time: 240000,
      input: '',
      cpfCnpj
    }
  },
  methods: {
    onChange(input) {
      this.input = cpfCnpj(input);
    },
    onKeyPress() {
        // params button
    },
    onInputChange(input) {
      this.input = input?.target.value;
      
    },
    handleMouse () {
      clearTimeout(this.handleSetTimeout)
      this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
    },
    handleSetTimeoutOutput () {
      clearTimeout(this.handleSetTimeout)
      this.$router.push('/standby')
    },
    handleForm(e) {
        e.preventDefault()
       
        if(this.$refs.form.validate()) {
          const code = unMaskSpecialChacaracters(this.input)

          this.isLoading = true

          const telycallback =  (response) => {
          if (response.status === 1) {
            const user = response.result[0]

            userStore.commit('setUser', user)

            createLog()

            this.isLoading = false

            this.$router.push('/invoice')
          } else {
            this.isLoading = false
            this.showMessage = true

            const typeMessage = code.length === 11 ? 'cpf' : 'cnpj'

            this.errorMessage = errorUserQuery[typeMessage]

            setTimeout(() => {
              this.errorMessage = ''
              this.showMessage = false
            }, 8000);
          }
        }

        telyApi.makeRequest(
          {
            ConsultaClientes : {
              Autenticacao: {
                ChaveIntegracao: config.ChaveIntegracao,
              },
              Filtro:`CNPJ_CNPF = ${code}`
            }
          },
            telycallback
          )
        }
      },
  },
  mounted () {
    if (this.$route.params.dev) {
      this.input = '41.151.622/0001-06'
    }
    this.handleMouse()
  },
  beforeMount () {
    const {id}  = adminStore.getters.admin
    if(!id && !this.$route.params.dev) {
      this.$router.push('/signinadmin');
    }
  },
  beforeDestroy () {
    clearTimeout(this.handleSetTimeout)
  }
}
</script>

<style scoped>
.white--text{
  color: #1A237E !important;
}
/* .login {
    overflow: hidden !important;
} */

/* .bg-image { */
  /* The image used */
  /* background-image: url('../../assets/background.png'); */
  
  /* Add the blur effect */
  /* filter: blur(24px); */
  /* -webkit-filter: blur(24px); */
  
  /* Full height */
  /* height: 100vh;  */
  
  /* Center and scale the image nicely */
  /* background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
} */

/* .login-area {
  background-color: rgb(0,0,0); 
  background-color: rgba(1, 220, 252, 0.6);
  color: white;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 100%;
  height: 100vh;
  padding: 20px;
  text-align: center;
} */

/* .section {
    position: absolute;
    top: 40%;
    width: 446px;
    height: 232px;
    left: 50%;
    transform: translate(-50%, -50%);
} */

.btn {
    height: 56px !important;
    box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4), 0px 6px 16px rgba(35, 41, 46, 0.2);
    border-radius: 16px !important;
}

.keyboard {
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  bottom: 15%;
  width: 100%;
  z-index: 999;
  margin: 0 auto;
}
</style>
